module.exports = __webpack_public_path__ + "static/media/modalImg4.4d3d2a74.png";